import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {InputField} from '@Components/input-field-v2';
import {ControlledAccordion} from '@Components/controlled-accordion';
import styles from './merge-tag-toggler.module.scss';
import type {MergeTagTogglerProps} from './merge-tag-toggler.types';
import {AccordionHeaderSpacing} from '@Components/controlled-accordion/controlled-accordion.types';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';
import {Text, TextSize} from '@Components/text';

export function MergeTagToggler({isOpenByDefault, ...props}: MergeTagTogglerProps): ReactElement<any> {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenByDefault ?? false);

  useEffect(() => {
    setIsOpen(isOpenByDefault ?? false);
  }, [isOpenByDefault]);

  const getHeader = (): ReactElement<any> => {
    return (
      <div className={`flexbox justify-content-between align-items-center ${styles.headerContent}`}>
        <div className="flexbox  align-items-center">
          <Icon icon={props.tag.icon} size={IconSize.SIZE_ICON_16} className="spacing-m-r-2" />
          <div>{window.i18next.t(props.tag.label)}</div>
        </div>
        <Icon
          icon={isOpen ? 'icon-delete' : 'icon-close'}
          className={`_position-absolute ${isOpen ? 'content-danger' : ''} ${styles.deleteIcon}`}
          size={IconSize.SIZE_ICON_16}
          type={isOpen ? IconType.DANGER : IconType.GHOST}
          shape={IconShape.NONE}
          isUsedAsButton
          onClick={props.onDelete}
        />
      </div>
    );
  };

  const handleToggle = (): void => {
    setIsOpen(!isOpen);
  };

  const getInputLabel = (): ReactElement<any> => {
    return (
      <div className="flexbox justify-content-start align-items-center flex-row-justify-between body-xxs-bold spacing-m-b-1">
        <div className="spacing-m-r-1 content-body">{window.i18next.t('pmwjs_default_value')}</div>
      </div>
    );
  };

  return (
    <ControlledAccordion
      header={getHeader()}
      openClasses={styles.mergeTagToggleOpen}
      className="border-s-dark spacing-m-b-3 radius-12"
      headerClassName="accordian-header radius-12 flex-justify-start _position-relative radius-4 flex-row-align-center flex-row-justify-start content-body"
      isOpen={isOpen}
      onHeaderClick={handleToggle}
      iconSize={IconSize.SIZE_ICON_16}
      removeHeaderHoverStateWhenOpen
      headerPadding={AccordionHeaderSpacing.CUSTOM}
      iconClassName="spacing-m-l-0"
    >
      <div className="spacing-p-3">
        {getInputLabel()}
        <InputField
          placeholder={window.i18next.t(props.placeholder ?? 'pmwjs_add_default_value')}
          onInputChange={props.onInputChange}
          input={props.defaultValue}
          size={InputFieldSize.XSMALL}
        />
        <div className="content-disabled flex-row-justify-between spacing-m-t-2">
          <div className="spacing-m-r-1">
            <Icon icon="icon-info" size={IconSize.SIZE_ICON_16} className="content-disabled" />
          </div>
          <Text val={window.i18next.t('pmwjs_missing_contact_details_default_value')} size={TextSize.XXSMALL} />
        </div>
      </div>
    </ControlledAccordion>
  );
}
